export const inputData = [
  {
    label: "Internal Pressure",
    variable: "Pi",
    txtFieldName: "txt_DP_CSC",
    required: true,
    inputProps: "N/mm^2",
    type: "number",
    pairField: "designInternalPressure",
  },
  {
    label: "Liquid Head Pressure",
    variable: "",
    txtFieldName: "txt_LH_CSC",
    required: true,
    inputProps: "N/mm^2",
    type: "number",
  },
  {
    label: "Design Temperature",
    variable: "T",
    txtFieldName: "txt_DT_CSC",
    required: true,
    inputProps: "N/mm^2",
    type: "number",
    pairField: "designTemperature",
  },
  {
    label: "Material Specification",
    variable: "",
    txtFieldName: "txt_MS_CSC",
    required: true,
    inputProps: "",
    type: "string",
  },
  {
    label: "Allowable Stress",
    variable: "S",
    txtFieldName: "txt_AS_CSC",
    required: true,
    inputProps: "N/mm^2",
    type: "number",
  },
  {
    label: "Joint Efficiency",
    variable: "E",
    txtFieldName: "txt_JE_CSC",
    required: true,
    inputProps: "ul",
    type: "number",
    pairField: "jointEffLong",
  },
  {
    label: "Inside/Outside Diameter",
    variable: "D",
    txtFieldName: "txt_ID_CSC",
    required: true,
    inputProps: "mm",
    type: "number",
    pairField: "vesselDiameter",
  },
  {
    label: "Provided Thk",
    variable: "T",
    txtFieldName: "txt_PT_CSC",
    required: true,
    inputProps: "mm",
    type: "number",
    pairField: "true",
  },
  {
    label: "Corrosion Allowance",
    variable: "CA",
    txtFieldName: "txt_CA_CSC",
    required: true,
    inputProps: "mm",
    type: "number",
  },
  {
    label: "Design Length of Shell",
    variable: "L",
    txtFieldName: "txt_DL_CSC",
    required: true,
    inputProps: "mm",
    type: "number",
    pairField: "vesselLengthSS",
  },
  {
    label: "External Pressure",
    variable: "Pe",
    txtFieldName: "externalPressureCSC",
    required: true,
    inputProps: "N/mm^2",
    type: "number",
    pairField: "designExternalPressure",
  },
];

export const ExternalPressureResults = [
  {
    label: "Geometry Factor",
    variable: "A",
    txtFieldName: "txt_AF_CSC",
    required: false,
    type: "number",
  },
  {
    label: "Materials Factor",
    variable: "B",
    txtFieldName: "txt_BF_CSC",
    required: false,
    type: "number",
  },
  {
    label: "Diameter/Thickness Ratio",
    variable: "Do/t",
    txtFieldName: "cscDoT",
    disabled: true,
    // required:false,
    type: "number",
  },
  {
    label: "Length/Diameter Ratio",
    variable: "L/Do",
    txtFieldName: "cscLDo",
    disabled: true,
    // required:false,
    type: "number",
  },
  {
    label: "EMAWP = ( 4 * B ) / ( 3 * D / T )",
    variable: "EMAWP",
    txtFieldName: "cscEMAWP",
    disabled: true,
    // required:false,
    type: "number",
    inputProps: "N/mm^2",
  },
];

export const Summary = [
  {
    label: "Req Thk + Corrosion Allowance for Int. Pressure",
    variable: "tr",
    txtFieldName: "cscReqThk",
    required: false,
    type: "number",
    inputProps: "mm",
  },
  {
    label: "Maximum Allowable Working Pressure",
    variable: "MAWP",
    txtFieldName: "cscMAWP",
    required: false,
    type: "number",
    inputProps: "N/mm^2",
  },
  {
    label: "Maximum Allowable Pressure",
    variable: "MAPNC",
    txtFieldName: "cscMAPNC",
    required: false,
    type: "number",
    inputProps: "N/mm^2",
  },
  {
    label: "Hydrotest pressure UG-99 (b)",
    variable: "1.3 * MAWP * Sa/S",
    txtFieldName: "cscHydrotestUG99b",
    required: false,
    type: "number",
    inputProps: "N/mm^2",
  },
  {
    label: "Hydrotest pressure UG-99 (c)",
    variable: "1.3 * MAPNC - Head",
    txtFieldName: "cscHydrotestUG99c",
    required: false,
    type: "number",
    inputProps: "N/mm^2",
  },
  {
    label: "Percent Elongation",
    variable: "(50*t/Rf * (1-Rf/Ro)",
    txtFieldName: "cscPercentElongation",
    required: false,
    type: "number",
    inputProps: "%",
  },
  {
    label: "MDMT w/o impact test per UCS-66",
    txtFieldName: "cscMDMTNoImpact",
    required: false,
    type: "number",
    inputProps: "F",
  },
  {
    label: "Diameter/Thickness Ratio",
    variable: "Do/t",
    txtFieldName: "cscDoTSummary",
    disabled: true,
    type: "number",
    pairField: "cscLDo",
  },
  {
    label: "Length/Diameter Ratio",
    variable: "L/Do",
    txtFieldName: "cscLDOSummary",
    disabled: true,
    type: "number",
    pairField: "cscDoT",
  },
  {
    label: "Maximum Allowable External Pressure",
    variable: "EMAWP",
    txtFieldName: "cscEMAWPSummary",
    required: false,
    type: "number",
    inputProps: "N/mm^2",
  },
];
